/**
 *
 * @ webuser-object to encapsulate
 *   webuser-functions
 * @ Author: olbe, 13.04.2015
 *
 */
var oWebUser =
    {
        // download report-files
        startDownload: function (sid, sortBy, filter, location, usertypefilter) {
            var postData = {};

            // data, which are not changeable by user
            postData.sid = sid;
            postData.action = "list";
            postData.sortby = sortBy;
            postData.filter_user = filter;
            postData.listaction = "usermanager";
            postData.filter_location = location;
            postData.filter_type = usertypefilter;

            // data, who can be changed by user before starting report
            postData.approver_flag = $("[name='approver_flag']").val();
            postData.auto_generate_flag = $("[name='auto_generate_flag']").val();

            // generate download
            oDownload.generate(
                "downloadXLS.phtml",
                postData,
                "POST"
            );
        }
    };

/**
 *
 * @ positonreport-object to encapsulate
 *   postionreport-functions
 * @ Author: joga, 07.09.2015
 *
 */
var oPositionreport =
    {
        // download positionreport-file
        startDownload: function (sid, sortBy, startDate, endDate) {
            var postData = {};

            // data, which are not changeable by user
            postData.sid = sid;
            postData.action = "positionreport_new";
            postData.sortby = sortBy;
            postData.startdate = startDate;
            postData.enddate = endDate;
            postData.listaction = "positionreport_new";

            // generate download
            oDownload.generate(
                "downloadXLS.phtml",
                postData,
                "POST"
            );
        }
    };


/**
 *
 * @ simple quick-download-object
 * @ Author: olbe, 13.04.2015
 *
 */
var oDownload =
    {
        iObjCount: 0,
        // generates and exports user-data
        generate: function (url, data, method) {
            // remove other messages
            classicErrrorMessage('');

            // prepare parameters
            var request_data = (typeof data === "string" ? data : $.param(data));

            // do the download-request
            oDownload.iObjCount++;
            var iDownloader = $("<iframe id='fr_" + oDownload.iObjCount + "' style='visibility:hidden;display:none;'/>");
            iDownloader.load(function () {
                if (iDownloader.contents().find("body").html().toUpperCase() === "FAIL") {
                    classicErrrorMessage(output['t_keine_daten_vorhanden']);
                }
            })
                .appendTo("body")
                .attr({src: url + "?" + request_data});
        },
        // downloads cartarticle-file
        attachment: function (sid, caid) {
            // remove other messages
            classicErrrorMessage();

            // do the download-request
            $("<iframe />").attr({
                src: './cartarticle_getfile.phtml?sid=' + sid + '&caid=' + caid,
                style: "display:none;visibility:hidden;"
            }).appendTo('body');
            return false;
        }
    };

/**
 *
 * @ simple quick-upload-object
 * @ Author: olbe, 08.06.2015
 *
 */
var oUpload =
    {
        formData: {},
        fileTypes: '',
        initFunc: null,
        // initializes the data-obj
        init: function () {
            oUpload.formData = {};
            oUpload.formData.sid = '';
            oUpload.formData.parameter = {};

            if (typeof (oUpload.initFunc) === 'function') {
                oUpload.initFunc();
            }
        },
        // uploads given file(s)
        start: function (event) {
            event.stopPropagation();
            event.preventDefault();
            classicErrrorMessage();

            var files = event.target.files;
            for (var i = 0, file; file = files[i]; i++) {
                var fileName = file.name;
                var fileExt = '.' + fileName.toLowerCase().split('.').pop();
                if (oUpload.fileTypes.toLowerCase().indexOf(fileExt) === -1) {
                    classicErrrorMessage("<font class='appMessage'>&nbsp;" + output['t_wrong_filetype'] + "&nbsp;</font>");
                    $('.appMessage').css('color', 'red');
                    return false;
                }
            }

            $('<div id="uploadOverlay"><img id="loading" src="' + mainURL + 'img/loadingimage.gif"></div>').appendTo('body');
            $(document).keyup(function (e) {
                if (e.which === 27) {
                    $('#uploadOverlay').remove();
                }
            });

            $.ajax({
                url: mainURL + 'ajax/Public/UploadFile/toFolder',
                type: 'POST',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    return myXhr;
                },
                success: function (responseData, textStatus, jqXHR) {
                    response = JSON.parse(responseData);

                    if (response.result === 'DONE') {
                        setTimeout(function () {
                            $('#uploadOverlay').remove();
                        }, 1000);
                        classicErrrorMessage("<font class='appMessage'>&nbsp;" + output['t_dateiupload_erfolgreich'] + "&nbsp;</font>");
                        $('.appMessage').css('color', 'green');
                    } else {
                        setTimeout(function () {
                            $('#uploadOverlay').remove();
                        }, 1000);
                        classicErrrorMessage("<font class='appMessage'>&nbsp;" + output['t_fehler_beim_dateiupload'] + "&nbsp;</font>");
                        $('.appMessage').css('color', 'red');
                    }

                    oUpload.init();
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    setTimeout(function () {
                        $('#uploadOverlay').remove();
                    }, 1000);
                    classicErrrorMessage("<font class='appMessage'>&nbsp;" + output['t_fehler_beim_dateiupload'] + "&nbsp;</font>");
                    $('.appMessage').css('color', 'red');

                    oUpload.init();
                },
                data: oUpload.formData,
                cache: false,
                contentType: false,
                processData: false
            });
        }
    };

/**
 *
 * @ Infor-Order-Export
 * @ Author: olbe, 26.03.2015
 *
 */
var oInforExport =
    {
        // exports order-data
        exportInforData: function (moduleName, monthBackValue) {
            document.body.style.cursor = 'wait';
            classicErrrorMessage(output['t_in_progress']);

            var data = {};
            data.cln = moduleName;
            data.lbc = monthBackValue;

            AjaxHandlerByClass(
                'ajax/infor/InforOrderExport/exportOrderData',
                data,
                function (response_data) {
                    switch ($.trim(response_data['result'])) {
                        case 'DONE':
                            classicErrrorMessage(output['m_data_exported']);
                            break;
                        case 'NODATA':
                            classicErrrorMessage(output['t_keine_daten_vorhanden']);
                            break;
                        default:
                            classicErrrorMessage(output['m_error_when_export']);
                            break;
                    }

                    document.body.style.cursor = 'default';
                },
                function (xhr, ajaxOptions, thrownError) {
                    classicErrrorMessage(output['m_error_when_export']);

                    document.body.style.cursor = 'default';
                }
            );
        },
        // shows an error-message
        databaseError: function () {
            classicErrrorMessage(output['m_database_connection_error']);
        }
    };

/**
 *
 * @ IBAN and BIC (SWIFT) checking
 * @ Author: olbe, 08.01.2015
 *
 */
var oBankCheck =
    {
        //check the swift code (ISO 9362)
        BIC: function (swift_code, error_message) {
            var regBIC = /^([a-zA-Z]){4}([a-zA-Z]){2}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$/;
            if (!regBIC.test(swift_code)) {
                if (error_message) {
                    classicErrrorMessage(error_message);
                }
                return false;
            }

            return true;
        },
        //check the iban code (ISO 7064)
        IBAN: function (iban_code, error_message) {
            var ibanCheck, charAt, cChar, bBanPattern, bBanCountryPatterns, regIBAN, i, p;
            var iban = iban_code.replace(/ /g, "").toUpperCase(),
                countryCode = iban.substring(0, 2),
                ibanCheckdigits = "",
                leadingZeroes = true,
                cOperator = "",
                cRest = "";

            // check the country code and find the country specific format
            // if there are new countries in future please complete list
            bBanCountryPatterns = {
                "AL": "\\d{8}[\\dA-Z]{16}",
                "AD": "\\d{8}[\\dA-Z]{12}",
                "AT": "\\d{16}",
                "AZ": "[\\dA-Z]{4}\\d{20}",
                "BE": "\\d{12}",
                "BH": "[A-Z]{4}[\\dA-Z]{14}",
                "BA": "\\d{16}",
                "BR": "\\d{23}[A-Z][\\dA-Z]",
                "BG": "[A-Z]{4}\\d{6}[\\dA-Z]{8}",
                "CR": "\\d{17}",
                "HR": "\\d{17}",
                "CY": "\\d{8}[\\dA-Z]{16}",
                "CZ": "\\d{20}",
                "DK": "\\d{14}",
                "DO": "[A-Z]{4}\\d{20}",
                "EE": "\\d{16}",
                "FO": "\\d{14}",
                "FI": "\\d{14}",
                "FR": "\\d{10}[\\dA-Z]{11}\\d{2}",
                "GE": "[\\dA-Z]{2}\\d{16}",
                "DE": "\\d{18}",
                "GI": "[A-Z]{4}[\\dA-Z]{15}",
                "GR": "\\d{7}[\\dA-Z]{16}",
                "GL": "\\d{14}",
                "GT": "[\\dA-Z]{4}[\\dA-Z]{20}",
                "HU": "\\d{24}",
                "IS": "\\d{22}",
                "IE": "[\\dA-Z]{4}\\d{14}",
                "IL": "\\d{19}",
                "IT": "[A-Z]\\d{10}[\\dA-Z]{12}",
                "KZ": "\\d{3}[\\dA-Z]{13}",
                "KW": "[A-Z]{4}[\\dA-Z]{22}",
                "LV": "[A-Z]{4}[\\dA-Z]{13}",
                "LB": "\\d{4}[\\dA-Z]{20}",
                "LI": "\\d{5}[\\dA-Z]{12}",
                "LT": "\\d{16}",
                "LU": "\\d{3}[\\dA-Z]{13}",
                "MK": "\\d{3}[\\dA-Z]{10}\\d{2}",
                "MT": "[A-Z]{4}\\d{5}[\\dA-Z]{18}",
                "MR": "\\d{23}",
                "MU": "[A-Z]{4}\\d{19}[A-Z]{3}",
                "MC": "\\d{10}[\\dA-Z]{11}\\d{2}",
                "MD": "[\\dA-Z]{2}\\d{18}",
                "ME": "\\d{18}",
                "NL": "[A-Z]{4}\\d{10}",
                "NO": "\\d{11}",
                "PK": "[\\dA-Z]{4}\\d{16}",
                "PS": "[\\dA-Z]{4}\\d{21}",
                "PL": "\\d{24}",
                "PT": "\\d{21}",
                "RO": "[A-Z]{4}[\\dA-Z]{16}",
                "SM": "[A-Z]\\d{10}[\\dA-Z]{12}",
                "SA": "\\d{2}[\\dA-Z]{18}",
                "RS": "\\d{18}",
                "SK": "\\d{20}",
                "SI": "\\d{15}",
                "ES": "\\d{20}",
                "SE": "\\d{20}",
                "CH": "\\d{5}[\\dA-Z]{12}",
                "TN": "\\d{20}",
                "TR": "\\d{5}[\\dA-Z]{17}",
                "AE": "\\d{3}\\d{16}",
                "GB": "[A-Z]{4}\\d{14}",
                "VG": "[\\dA-Z]{4}\\d{16}"
            };
            bBanPattern = bBanCountryPatterns[countryCode];

            // countryCode found?
            if (typeof bBanPattern !== "undefined") {
                regIBAN = new RegExp("^[A-Z]{2}\\d{2}" + bBanPattern + "$", "");
                if (!regIBAN.test(iban)) {
                    if (error_message) {
                        classicErrrorMessage(error_message);
                    }
                    return false;
                }
            }

            // now check the checksum, first convert to digits
            ibanCheck = iban.substring(4, iban.length) + iban.substring(0, 4);
            for (i = 0; i < ibanCheck.length; i++) {
                charAt = ibanCheck.charAt(i);
                if (charAt !== "0") {
                    leadingZeroes = false;
                }
                if (!leadingZeroes) {
                    ibanCheckdigits += "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(charAt);
                }
            }

            // calculate the result of: ibanCheckdigits % 97
            for (p = 0; p < ibanCheckdigits.length; p++) {
                cChar = ibanCheckdigits.charAt(p);
                cOperator = "" + cRest + "" + cChar;
                cRest = cOperator % 97;
            }

            if (cRest === 1) {
                return true;
            }

            if (error_message) {
                classicErrrorMessage(error_message);
            }
            return false;
        }
    };


/**
 *
 * @ check credit, etc..
 * @ Author: olbe, 27.01.2015
 *
 */
var oCredit =
    {
        // calculate the new offset from maximum catalog-points at current position
        calkPoints: function (curr_id, curr_val, offs_val, error_title, error_msg) {
            var new_offset = (parseInt(curr_val) + parseInt(offs_val));
            if (new_offset < 0) {
                oDialog.message(error_title, error_msg);
                return curr_val;
            } else {
                var data = {};
                data.id = curr_id;
                data.offset = new_offset;

                AjaxHandlerByClass(
                    'ajax/Credit/CreditPointsManipulation/updateCreditOffset',
                    data,
                    function (response_data) {
                        if (response_data['result'] === '1') {
                            classicErrrorMessage(output['m_new_credit_saved']);
                        } else {
                            classicErrrorMessage(output['m_error_save']);
                        }
                    },
                    function (xhr, ajaxOptions, thrownError) {
                        classicErrrorMessage(output['m_error_save']);
                    });

                return new_offset;
            }
        },
        // calculate the new offset from maximum catalog-points for filtered positions
        calkAllPoints: function (offs_val, selection_data, callback_success) {
            var data = selection_data;
            data.offset = offs_val;

            AjaxHandlerByClass(
                'ajax/Credit/CreditPointsManipulation/updateCreditOffsetForSelection',
                data,
                function (response_data) {
                    switch (response_data['result']) {
                        case('1'):
                            classicErrrorMessage(output['m_new_credit_saved']);
                            if (typeof (callback_success) === 'function') {
                                callback_success();
                            }
                            break;
                        case('2'):
                            classicErrrorMessage(output['m_nothing_to_save']);
                            break;
                        default:
                            classicErrrorMessage(output['m_error_save']);
                            break;
                    }
                },
                function (xhr, ajaxOptions, thrownError) {
                    classicErrrorMessage(output['m_error_save']);
                });
        }
    };

/**
 *
 * @ input-dialog, etc..
 * @ Author: olbe, 26.01.2015
 *
 */
var oDialog =
    {
        //open input-dialog (ext-js-based)
        input: function (dialog_title, message_prompt, ok_function, value_type, default_value) {
            if (value_type === 'i') {
                var mbtext = Ext.Msg.textField;
                mbtext.maskRe = /[-,0-9:]/;
                mbtext.regex = /[-,0-9]+(:[-,0-9]+)?/;
            }
            var v = '';
            if (typeof (default_value) === 'string' || typeof (default_value) === 'number') {
                v = default_value;
            }

            Ext.Msg.prompt(dialog_title, message_prompt, function (btn, text) {
                if (btn === 'ok') {
                    if (typeof (ok_function) === 'function') {
                        return ok_function(text);
                    }
                }
            }, null, null, v);
        },
        yesno: function (dialog_title, message_prompt, close_function) {
            Ext.MessageBox.show({
                title: dialog_title,
                msg: message_prompt,
                buttons: Ext.MessageBox.YESNO,
                fn: function (btn) {
                    if (typeof (close_function) === 'function') {
                        return close_function(btn.toLowerCase());
                    }
                },
                icon: Ext.MessageBox.QUESTION
            });
        },
        message: function (dialog_title, message_prompt, ok_function) {
            Ext.MessageBox.alert(dialog_title, message_prompt, function (btn, text) {
                if (btn === 'ok') {
                    if (typeof (ok_function) === 'function') {
                        return ok_function();
                    }
                }
            });
        }
    };


/**
 *
 * @ update freetext seller email.
 * @ Author: joga, 07.04.2015
 *
 */
var freetext_seller_object =
    {
        /* Function to update freetext-seller-eMail
         * when there is a valid email written,
         * then rewrite the CSV/XML File and retryErel()
         * @param {type} email
         * @param {type} cart_id
         * @returns a OK message when the email was valid, otherwise return an Error Message
         *
         */
        updateFreetextSellerEmail: function (email, cart_id, pending) {

            var validEmail = emailValidation(email);

            if (!validEmail) {
                classicErrrorMessage(output['e_email_ungueltig']);
            } else {

                var data = {};
                data.email = email;
                data.cart_id = cart_id;

                AjaxHandlerByClass(
                    'ajax/Administration/Partner/updateFreetextSellerEmail',
                    data,
                    function (response_data) {
                        if (response_data['result'] === '1') {
                            classicErrrorMessage(output['m_freetext_seller_email_updated']);
                            if (!pending) {
                                document.rewriteorderfilesform.rewritecsvxml.value = 'Y'; //rewrite CSV/XML
                                document.rewriteorderfilesform.retryerel.value = 'Y'; //retryErel
                                document.rewriteorderfilesform.submit();
                            }
                        } else {
                            classicErrrorMessage(output['m_freetext_seller_email_empty']);
                        }
                    },
                    function (xhr, ajaxOptions, thrownError) {
                        classicErrrorMessage(output['m_freetext_seller_email_empty']);
                    }
                );
            }
        }
    }


/**
 *
 * @ exportCatalogTemplate-object to encapsulate
 *   exportCatalogTemplate-functions
 * @ Author: joga, 05.10.2015
 *
 */
var oExportCatalogTemplate =
    {
        // download catalogTemplate
        startDownload: function (catalogname, catalog_id, clientname, articlecount) {

            var data = {};

            disablePageOnDataLoad();
            
            // data, which are not changeable by user
            data.catalogname = catalogname;
            data.catalog_id = catalog_id;
            data.clientname = clientname;
            data.articlecount = articlecount;
            data.action = "export_catalog_template";
            data.listaction = "export_catalog_template";

            AjaxHandlerByClass(
                'ajax/Administration/Catalog/initCatalogDownload',
                data,
                function (response_data) {
                    updateExportTemplateCatalog(response_data);
                },
                function (xhr, ajaxOptions, thrownError) {
                    notification.info(output['m_error_when_export']);
                }
            );
        }
    };


/**
 *
 * encapsulates functions to handle
 * contact-location-assignment
 *
 * @ Author: olbe, 06.07.2015
 *
 */
var oContact =
    {
        /**
         *
         * @type Ext.LoadMask
         *
         * loading-mask
         */
        dlgMask: null,
        /**
         *
         * @type interval
         *
         * interval-handle
         */
        interVal: null,
        /**
         *
         * @type String|type
         *
         * initial-data
         */
        contactId: '',
        partnerId: '',
        webuserId: '',
        /**
         *
         * @type @exp;JSON@call;parse
         *
         * main-data-arrays
         */
        locationData: {},
        assignedLocationData: {},
        /**
         *
         * @type Boolean|Boolean|Boolean
         *
         * how's the window been closed
         */
        closedbyOKButton: false,
        /**
         *
         * @type Boolean|Boolean|Boolean
         *
         * shows debug-message in console's log if true
         */
        debug: true,
        /**
         *
         * @type String|String|@call;$@call;html
         *
         * dynamic option-variable for
         * the main-data selector
         *
         */
        locationOptions: '',
        /**
         *
         * @param {type} sText
         * @returns nothing
         *
         * displays debug-messages in console-log
         */
        printDebug: function (sText) {
            if (oContact.debug) {
                try {
                    console.log(sText);
                } catch (e) {
                }
            }
        },
        /**
         *
         * @param {type} contactId
         * @param {type} partnerId
         * @param {type} webuserId
         *
         * @returns nothing
         *
         * opens the dialog to select locations per contact
         */
        showAssignLocationDlg: function (contactId, partnerId, webuserId) {
            // quickly implement jquery-mini-widget for multi-select
            $.fn.multiselect = function () {
                $(this).each(function () {
                    var checkboxes = $(this).find('input:checkbox');
                    checkboxes.each(function () {
                        var checkbox = $(this);
                        if (checkbox.prop('checked')) {
                            checkbox.parent().addClass('location_select-on');
                        }
                        checkbox.click(function () {
                            if (checkbox.prop('checked')) {
                                checkbox.parent().addClass('location_select-on');
                            } else {
                                checkbox.parent().removeClass('location_select-on');
                            }
                        });
                    });
                });
            };

            oContact.contactId = contactId;
            oContact.partnerId = partnerId;
            oContact.webuserId = webuserId;

            oContact.dlgMask = new Ext.LoadMask(Ext.getBody(), {msg: output['t_data_beeing_loaded']});
            oContact.dlgMask.show();

            oContact.assignedLocationData = {};

            oContact.printDebug('start loading data...');
            oContact.loadData(contactId, partnerId, function () {
                classicErrrorMessage("");
                oContact.closedbyOKButton = false;

                oContact.printDebug('data loaded: ' + oContact.locationData.dataStatus);
                // canalise what happened, when loading data...
                if (oContact.locationData.dataStatus === 'SUCCESS' &&
                    (oContact.assignedLocationData.dataStatus === 'NODATA' ||
                        oContact.assignedLocationData.dataStatus === 'SUCCESS')) {

                    // creates the dialog-window
                    oContact.printDebug('showing dialog now...');
                    oContact.createWindow();
                } else if (oContact.locationData.dataStatus === 'NODATA') {
                    alert(output['t_es_wurden_keine_standorte_gefunden']);
                }
            });
        },
        /**
         *
         * @returns nothing
         *
         * creates the dialog-window
         *
         */
        createWindow: function () {
            Ext.create('Ext.Window', {
                title: '<font style="color:black;text-weight:bold;">' + output['t_assign_location_hint'] + '</font>',
                plain: true,
                width: 280,
                height: 523,
                resizable: false,
                closable: true,
                draggable: false,
                buttons: [
                    {
                        text: output['t_ok'],
                        listeners: {
                            click: {
                                fn: function () {
                                    oContact.closedbyOKButton = true;

                                    var assignedLocationData = oContact.assignedLocationData;
                                    delete assignedLocationData.savedStatus;
                                    delete assignedLocationData.dataStatus;
                                    delete assignedLocationData.result;
                                    oContact.storeAssignedLocationData(oContact.contactId, JSON.stringify(assignedLocationData));
                                    this.up('.window').close();
                                }
                            }
                        }
                    },
                    {
                        text: output['b_abbrechen'],
                        listeners: {
                            click: {
                                fn: function () {
                                    oContact.closedbyOKButton = false;
                                    this.up('.window').close();
                                }
                            }
                        }
                    }
                ],
                autoLoad: 'modules/extjs/contactLocation/app/view/locationAssignmentDialog.phtml',
                modal: true,
                listeners: {
                    close: function () {
                        if (oContact.interVal !== null) {
                            clearInterval(oContact.interVal);
                            oContact.interVal = null;
                        }
                        if (!oContact.closedbyOKButton) {

                        }
                    },
                    afterlayout: function () {
                        setTimeout(function () {
                            oContact.dlgMask.hide();
                        }, 200);

                        if (oContact.interVal === null) {
                            oContact.interVal = setInterval(function () {
                                oContact.printDebug('tracking for "assignableLocations"...');
                                if (Ext.get('assignableLocations')) {
                                    oContact.printDebug('"assignableLocations" found');
                                    clearInterval(oContact.interVal);
                                    oContact.createAssignedLocations();
                                    oContact.interVal = null;
                                }
                            }, 500);
                        }
                        $('#assignableLocations').focus();
                    }
                }
            }).show();
        },
        /**
         *
         * @returns nothing
         *
         * creates the content of multiple-location-select
         *
         */
        createAssignedLocations: function () {
            oContact.printDebug('iterating through datalist...');

            var totalCount = 0;
            var assignedCount = 0;
            oContact.locationOptions = '';
            for (var elem in oContact.locationData.dataList) {
                if (oContact.locationData.dataList[elem] !== null) {
                    totalCount++;
                    var opt_id = oContact.locationData.dataList[elem].id;
                    var bAssigned = false;
                    for (var subElem in oContact.assignedLocationData.dataList) {
                        if (oContact.assignedLocationData.dataList[subElem].id === opt_id) {
                            assignedCount++;
                            bAssigned = true;
                        }
                    }
                    oContact.locationOptions +=
                        '<label>' +
                        (bAssigned
                                ? '<input class="inner_loc_select" id="' + opt_id + '" type="checkbox" style="margin-right:20px" value="1" checked />'
                                : '<input class="inner_loc_select" id="' + opt_id + '" type="checkbox" style="margin-right:20px" value="0" />'
                        ) +
                        '<font>' +
                        (oContact.locationData.dataList[elem].code !== '' ?
                            oContact.locationData.dataList[elem].code + ' - ' :
                            '') +
                        oContact.locationData.dataList[elem].name +
                        '</font>' +
                        '</label>';
                }
            }

            oContact.printDebug('optionen: ' + oContact.locationOptions);
            $('#assignableLocations').html(oContact.locationOptions);
            $('.location_select').multiselect();

            $('.inner_loc_select').change(function () {
                $(this).val(($(this).prop('checked') ? 1 : 0));
                oContact.printDebug('changing option ' + $(this).prop('id') + ' (' + $(this).parent().find('font').html() + '): ' + ($(this).prop('checked') ? 'checked' : 'un-checked') + '/' + $(this).val());

                if (oContact.assignedLocationData.dataList === undefined) {
                    oContact.assignedLocationData.dataList = [];
                }

                var elemInList = false;
                for (var elem in oContact.assignedLocationData.dataList) {
                    if (parseInt(oContact.assignedLocationData.dataList[elem].id) === parseInt($(this).prop('id'))) {
                        if (!$(this).prop('checked')) {
                            oContact.assignedLocationData.dataList.splice(elem, 1);
                            break;
                        }
                        elemInList = true;
                    }
                }
                if ($(this).prop('checked')) {
                    if (!elemInList) {
                        oContact.assignedLocationData.dataList.push({'id': $(this).prop('id')});
                    }
                }
                oContact.printDebug('the list: ' + JSON.stringify(oContact.assignedLocationData));

                oContact.testCheckAll();
            });

            setTimeout(function () {
                var checkedCount = 0;
                $('.location_select').find('label').each(function () {
                    if ($(this).find('input').attr('checked')) {
                        checkedCount++;
                    }
                });

                $('#checkAll').prop('checked', (totalCount === checkedCount));
            }, 200);

            oContact.testCheckAll();
        },
        /**
         *
         * @returns nothing
         *
         * handler for checking/unchecking all locations
         *
         */
        doCheckAll: function () {
            $('.location_select').find('label').each(function () {
                if ($('#checkAll').prop('checked')) {
                    $(this).find('input').attr('checked', true);
                    $(this).addClass('location_select-on');
                    $(this).find('input').val('1');
                } else {
                    $(this).find('input').attr('checked', false);
                    $(this).removeClass('location_select-on');
                    $(this).find('input').val('0');
                }

                $(this).find('input').change();
            });
        },
        /**
         *
         * @returns nothing
         *
         * testing if all locations checked
         *
         */
        testCheckAll: function () {
            var totalCount = 0;
            var checkedCount = 0;
            $('.location_select').find('label').each(function () {
                totalCount++;
                if ($(this).find('input').attr('checked')) {
                    checkedCount++;
                }
            });
        },
        /**
         *
         * @param {type} contactId
         * @param {type} partnerId
         * @param {type} successFunction
         * @returns nothing
         *
         * loads neccessary data for the selection-
         * dialog in cascading manner
         *
         */
        loadData: function (contactId, partnerId, successFunction) {
            oContact.contactId = contactId;
            oContact.partnerId = partnerId;

            oContact.printDebug('1');
            if ((oContact.locationData.dataList === undefined || oContact.locationData.dataList.length === 0) ||
                (oContact.assignedLocationData.dataList === undefined || oContact.assignedLocationData.dataList.length === 0)) {
                oContact.printDebug('2');
                oContact.loadLocationData(
                    partnerId,
                    function () {
                        oContact.printDebug('3');
                        if ((oContact.assignedLocationData.dataList === undefined || oContact.assignedLocationData.dataList.length === 0)) {
                            oContact.printDebug('4');
                            oContact.loadAssignedLocationData(
                                contactId,
                                function () {
                                    oContact.printDebug('5');
                                    if (typeof (successFunction) === 'function') {
                                        successFunction();
                                    }
                                });
                        } else {
                            oContact.printDebug('6');
                            if (typeof (successFunction) === 'function') {
                                successFunction();
                            }
                        }
                    });
            } else {
                oContact.printDebug('7');
                if (typeof (successFunction) === 'function') {
                    successFunction();
                }
            }
        },
        /**
         *
         * @param {type} partnerId
         * @param {type} successFunction
         * @returns nothing
         *
         * loads all locations from partner
         *
         */
        loadLocationData: function (partnerId, successFunction) {
            oContact.locationData.dataStatus = 'NODATA';

            var params = {};
            params.partner_id = partnerId;

            AjaxHandlerByClass(
                'ajax/LocationContact/RequestHandler/LoadLocationData',
                params,
                function (response_data) {
                    oContact.locationData.result = oJSFunc.getObj('result', response_data);
                    /*                  oContact.locationData = JSON.parse(response_data.substring(1, response_data.length-1));
                     oContact.printDebug('loadLocationData: '+response_data+'\r\n -->'+oContact.locationData.result);*/

                    switch (oContact.locationData.result) {
                        case 'DONE':
                            oContact.locationData.dataList = oJSFunc.getObj('dataList', response_data);
                            oContact.locationData.dataStatus = 'SUCCESS';
                            break;
                        case 'NODATA':
                            oContact.locationData.dataStatus = 'NODATA';
                            break;
                        default:
                            oContact.locationData.dataStatus = 'ERROR';
                            break;
                    }
                    if (oContact.locationData.dataList) {
                        oContact.printDebug('loadLocationData: ' + oJSFunc.getObjStr(response_data) + '\r\n -->' + oContact.locationData.dataList);
                    } else {
                        oContact.printDebug('loadLocationData: ' + oJSFunc.getObjStr(response_data) + '\r\n -->' + oContact.locationData.result);
                    }

                    if (typeof (successFunction) === 'function') {
                        successFunction();
                    }
                },
                function (xhr, ajaxOptions, thrownError) {
                    oContact.printDebug('loadLocationData: ' + oContact.locationData.result + '\r\n -->' + thrownError);
                    oContact.locationData.dataStatus = 'ERROR';
                }
            );
        },
        /**
         *
         * @param {type} contactId
         * @param {type} successFunction
         * @returns nothing
         *
         * loads all assigned locations from contact
         *
         */

        loadAssignedLocationData: function (contactId, successFunction) {
            oContact.assignedLocationData.dataStatus = 'NODATA';

            var params = {};
            params.contact_id = contactId;

            AjaxHandlerByClass(
                'ajax/LocationContact/RequestHandler/LoadAssignedLocationData',
                params,
                function (response_data) {
                    oContact.assignedLocationData.result = oJSFunc.getObj('result', response_data);

                    switch (oContact.assignedLocationData.result) {
                        case 'DONE':
                            oContact.assignedLocationData.dataList = oJSFunc.getObj('dataList', response_data);
                            oContact.assignedLocationData.dataStatus = 'SUCCESS';
                            break;
                        case 'NODATA':
                            oContact.assignedLocationData.dataStatus = 'NODATA';
                            break;
                        default:
                            oContact.assignedLocationData.dataStatus = 'ERROR';
                            break;
                    }
                    if (oContact.assignedLocationData.dataList) {
                        oContact.printDebug('loadAssignedLocationData: ' + oJSFunc.getObjStr(response_data) + '\r\n -->' + oContact.assignedLocationData.dataList);
                    } else {
                        oContact.printDebug('loadAssignedLocationData: ' + oJSFunc.getObjStr(response_data) + '\r\n -->' + oContact.assignedLocationData.result);
                    }

                    if (typeof (successFunction) === 'function') {
                        successFunction();
                    }
                },
                function (xhr, ajaxOptions, thrownError) {
                    oContact.printDebug('loadAssignedLocationData: ' + oContact.assignedLocationData.result + '\r\n -->' + thrownError);
                    oContact.assignedLocationData.dataStatus = 'ERROR';
                }
            );
        },
        /**
         *
         * @param {type} contactId
         * @param {type} assignedLocations
         * @param {type} successFunction
         * @returns nothing
         *
         * assigned locations for choosen contact
         *
         */
        storeAssignedLocationData: function (contactId, assignedLocations, successFunction) {
            if (assignedLocations === null || assignedLocations.length === 0) {
                return;
            }

            var params = {};
            params.contact_id = contactId;
            params.assigned_locations = assignedLocations;
            oContact.printDebug('storing: ' + JSON.stringify(params));

            oContact.assignedLocationData.savedStatus = 'ERROR';

            AjaxHandlerByClass(
                'ajax/LocationContact/RequestHandler/StoreAssignedLocationData',
                params,
                function (response_data) {
                    var storeListResponse = {};
                    storeListResponse.result = oJSFunc.getObj('result', response_data);

                    switch (storeListResponse.result) {
                        case 'DONE':
                            oContact.assignedLocationData.savedStatus = 'SUCCESS';

                            var params = {};
                            params.contact_id = contactId;
                            params.partner_id = oContact.partnerId;
                            params.webuser_id = oContact.webuserId;
                            params.text = output['t_and_more'];
                            AjaxHandlerByClass(
                                'ajax/LocationContact/RequestHandler/GetAssignedLocationHints',
                                params,
                                function (response_data) {
                                    var assignedLocationHint = {};
                                    assignedLocationHint.result = oJSFunc.getObj('result', response_data);
                                    assignedLocationHint.dataList = oJSFunc.getObj('dataList', response_data);
                                    oContact.printDebug('LocationHint: ' + oJSFunc.getObjStr(response_data) + '\r\n -->' + assignedLocationHint.dataList);

                                    if ($.trim(assignedLocationHint.dataList) !== '') {
                                        $('#' + contactId).attr('title', assignedLocationHint.dataList);
                                    }
                                },
                                function (xhr, ajaxOptions, thrownError) {
                                });
                            break;
                        case 'EMPTY':
                            alert(output['t_assignment_removed']);
                            oContact.assignedLocationData.savedStatus = 'SUCCESS';
                            $('#' + contactId).attr('title', output['t_assign_location_hint']);
                            break;
                        default:
                            alert(output['m_error_save']);
                            oContact.assignedLocationData.savedStatus = 'ERROR';
                            break;
                    }
                    oContact.printDebug('StoreAssignedLocationData: ' + oJSFunc.getObjStr(response_data) + '\r\n -->' + storeListResponse.result);

                    if (typeof (successFunction) === 'function') {
                        successFunction();
                    }
                },
                function (xhr, ajaxOptions, thrownError) {
                    oContact.printDebug('StoreAssignedLocationData: ' + storeListResponse.result + '\r\n -->' + thrownError);
                    oContact.assignedLocationData.savedStatus = 'ERROR';
                    alert(output['m_error_save']);
                }
            );
        }

    };

/**
 *
 * encapsulates functions to
 * handle mail-receiver-list
 *
 * @ Author: olbe, 21.04.2015
 *
 */
var oMailList =
    {
        /**
         *
         * @type Ext.LoadMask
         *
         * loading-mask
         */
        dlgMask: null,
        /**
         *
         * @type String|type
         *
         * initial-data
         */
        cartId: '',
        partnerId: '',
        /**
         *
         * @type @exp;JSON@call;parse
         *
         * main-data-arrays
         */
        userData: {},
        locationData: {},
        mailListData: {},
        /**
         *
         * @type Boolean|Boolean|Boolean
         *
         * is the filter just doing his work?
         */
        filterInProgress: false,
        /**
         *
         * @type Boolean|Boolean|Boolean
         *
         * how's the window been closed
         */
        closedbyOKButton: false,
        /**
         *
         * @type String|String|@call;$@call;html
         *
         * dynamic option-variables for
         * the main-data selectors
         *
         */
        selectedUserOptions: '',
        selectableUserOptions: '',
        locationFilterOptions: '',
        /**
         *
         * @param {type} cartID
         * @param {type} partnerID
         *
         * @returns nothing
         *
         * opens the dialog to select users per location for info-mail
         */
        showMailReceiverDlg: function (cartID, partnerID) {
            oMailList.dlgMask = new Ext.LoadMask(Ext.getBody(), {msg: output['t_data_beeing_loaded']});
            oMailList.dlgMask.show();

            oMailList.loadData(cartID, partnerID, function () {
                classicErrrorMessage("");
                oMailList.closedbyOKButton = false;

                oMailList.selectedUserOptions = '';
                oMailList.selectableUserOptions = '';
                oMailList.locationFilterOptions = '';

                // canalise what happened, when loading data...
                if (oMailList.userData.dataStatus === 'SUCCESS' &&
                    oMailList.locationData.dataStatus === 'SUCCESS') {
                    for (elem in oMailList.locationData.dataList) {
                        if (oMailList.locationData.dataList[elem] !== null) {
                            oMailList.locationFilterOptions +=
                                "<option value='" +
                                oMailList.locationData.dataList[elem].id + "'>" +
                                (oMailList.locationData.dataList[elem].code !== '' ?
                                    oMailList.locationData.dataList[elem].code + " - " :
                                    '') +
                                oMailList.locationData.dataList[elem].name +
                                "</option>";
                        }
                    }
                    oMailList.filterDisplayedData();
                    for (elem in oMailList.mailListData.dataList) {
                        if (oMailList.mailListData.dataList[elem] !== null) {
                            oMailList.selectedUserOptions +=
                                "<option value='" +
                                oMailList.mailListData.dataList[elem].id + "'>" +
                                oMailList.mailListData.dataList[elem].name +
                                "</option>";
                        }
                    }

                    // creates the dialog-window
                    oMailList.createWindow();
                } else if (oMailList.userData.dataStatus === 'NODATA') {
                    alert(output['t_es_wurden_keine_benutzer_gefunden']);
                } else if (oMailList.locationData.dataStatus === 'NODATA') {
                    alert(output['t_es_wurden_keine_standorte_gefunden']);
                } else if (oMailList.userData.dataStatus === 'ERROR' ||
                    oMailList.locationData.dataStatus === 'ERROR') {
                    alert(output['c_fehler_beim_laden_der_user_location_daten']);
                }
            });
        },
        /**
         *
         * @returns nothing
         *
         * moves the (multiple) selected user(s)
         * from the 'available' users list to the
         * 'selected' users list.
         *
         */
        moveToSelectedUsers: function () {
            $('#selectableUsers option:selected').each(function () {
                oMailList.selectedUserOptions +=
                    "<option value='" +
                    $(this).val() + "'>" +
                    $(this).text() +
                    "</option>";

                oMailList.moveListElement(parseInt($(this).val()), oMailList.userData, oMailList.mailListData);
                $(this).remove();
            });
            oMailList.selectableUserOptions = $('#selectableUsers').html();

            $('#selectedUsers').html(oMailList.selectedUserOptions);
            oMailList.sortOptions('selectedUsers');
        },
        /**
         *
         * @returns {undefined}
         *
         * moves the (multiple) selected user(s)
         * from the 'selected' users list to the
         * 'available' users list.
         *
         */
        moveToAvailableUsers: function () {
            $('#selectedUsers option:selected').each(function () {
                oMailList.selectableUserOptions +=
                    "<option value='" +
                    $(this).val() + "'>" +
                    $(this).text() +
                    "</option>";

                oMailList.moveListElement(parseInt($(this).val()), oMailList.mailListData, oMailList.userData);
                $(this).remove();
            });
            oMailList.selectedUserOptions = $('#selectedUsers').html();

            $('#selectableUsers').html(oMailList.selectableUserOptions);
            oMailList.sortOptions('selectableUsers');
        },
        /**
         *
         * @param {type} id
         * @param {type} fromList
         * @param {type} toList
         * @returns nothing
         *
         * moves an element with given id
         * of a json- structure to another
         * json-structure
         *
         */
        moveListElement: function (id, fromList, toList) {
            for (elem in fromList.dataList) {
                if (parseInt(fromList.dataList[elem].id) === id) {
                    if (toList.dataList === undefined) {
                        toList.dataList = [];
                    }
                    toList.dataList.push(
                        {
                            'id': fromList.dataList[elem].id,
                            'name': fromList.dataList[elem].name,
                            'email': fromList.dataList[elem].email,
                            'location_id': fromList.dataList[elem].location_id,
                            'location_name': fromList.dataList[elem].location_name
                        }
                    );
                    delete fromList.dataList[elem];
                    break;
                }
            }
        },
        /**
         *
         * @param {type} id
         * @returns nothing
         *
         * sorts select-options after manipulating
         *
         */
        sortOptions: function (id) {
            $('#' + id).append($('#' + id + ' option').remove().sort(function (a, b) {
                var at = $(a).text().toLowerCase(), bt = $(b).text().toLowerCase();
                return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
            }));
        },
        /**
         *
         * @returns nothing
         *
         * displays only users which are matching
         * the name-filter or the location-filter
         *
         */
        filterDisplayedData: function () {
            if (oMailList.filterInProgress) {
                return;
            }
            oMailList.filterInProgress = true;
            oMailList.selectableUserOptions = '';

            if ($('#locationFilter').val() === undefined || parseInt($('#locationFilter').val()) === -2) {
                for (elem in oMailList.userData.dataList) {
                    if (oMailList.userData.dataList[elem] !== null && oMailList.userData.dataList[elem].name !== undefined && oMailList.userData.dataList[elem].name !== null) {
                        if ($('#nameFilter').val() === undefined || $('#nameFilter').val() === '' ||  $('#nameFilter').val() === null) {
                            oMailList.selectableUserOptions +=
                                "<option value='" +
                                oMailList.userData.dataList[elem].id + "'>" +
                                oMailList.userData.dataList[elem].name +
                                "</option>";
                        } else {
                            var s = oMailList.userData.dataList[elem].name.toLowerCase();
                            var f = $('#nameFilter').val().toLowerCase();
                            if (s.indexOf(f) === 0) {
                                oMailList.selectableUserOptions +=
                                    "<option value='" +
                                    oMailList.userData.dataList[elem].id + "'>" +
                                    oMailList.userData.dataList[elem].name +
                                    "</option>";
                            }
                        }
                    }
                }
            } else {
                for (elem in oMailList.userData.dataList) {
                    if (oMailList.userData.dataList[elem] !== null && oMailList.userData.dataList[elem].name !== undefined && oMailList.userData.dataList[elem].name != null) {
                        if (($('#nameFilter').val() === undefined || $('#nameFilter').val() === '' || $('#nameFilter').val() === null) ||
                            oJSFunc.jsXOR((parseInt(oMailList.userData.dataList[elem].location_id) === parseInt($('#locationFilter').val())),
                                (parseInt($('#locationFilter').val()) === -1 && oMailList.userData.dataList[elem].location_id.length === 0))) {
                            oMailList.selectableUserOptions +=
                                "<option value='" +
                                oMailList.userData.dataList[elem].id + "'>" +
                                oMailList.userData.dataList[elem].name +
                                "</option>";
                        } else {
                            var s = oMailList.userData.dataList[elem].name.toLowerCase();
                            var f = $('#nameFilter').val().toLowerCase();
                            if ((s.indexOf(f) === 0) &&
                                oJSFunc.jsXOR((parseInt(oMailList.userData.dataList[elem].location_id) === parseInt($('#locationFilter').val())),
                                    (parseInt($('#locationFilter').val()) === -1 && oMailList.userData.dataList[elem].location_id.length === 0))) {
                                oMailList.selectableUserOptions +=
                                    "<option value='" +
                                    oMailList.userData.dataList[elem].id + "'>" +
                                    oMailList.userData.dataList[elem].name +
                                    "</option>";
                            }
                        }
                    }
                }
            }

            $('#selectableUsers').html(oMailList.selectableUserOptions);
            setTimeout(function () {
                oMailList.sortOptions('selectableUsers');
            }, 200);
            oMailList.filterInProgress = false;
        },
        /**
         *
         * @returns nothing
         *
         * creates the dialog-window
         *
         */
        createWindow: function () {
            Ext.create("Ext.Window", {
                title: '<font style="color:black;text-weight:bold;">' + output['t_mail_receiver_hint'] + '</font>',
                plain: true,
                width: 420,
                height: 500,
                resizable: false,
                closable: true,
                draggable: false,
                buttons: [
                    {
                        text: output['t_ok'],
                        listeners: {
                            click: {
                                fn: function () {
                                    oMailList.closedbyOKButton = true;
                                    this.up('.window').close();

                                    var storedMailList = oMailList.mailListData;
                                    delete storedMailList.savedStatus;
                                    delete storedMailList.dataStatus;
                                    delete storedMailList.result;

                                    oMailList.storeMailListData(oMailList.cartId, JSON.stringify(storedMailList));
                                }
                            }
                        }
                    },
                    {
                        text: output['b_abbrechen'],
                        listeners: {
                            click: {
                                fn: function () {
                                    oMailList.closedbyOKButton = false;
                                    this.up('.window').close();
                                }
                            }
                        }
                    }
                ],
                autoLoad: 'modules/extjs/OrderInfoMail/app/view/userListDialog.phtml',
                modal: true,
                listeners: {
                    close: function () {
                        if (!oMailList.closedbyOKButton) {
                            oMailList.loadData(oMailList.cartId, oMailList.partnerId);
                        }
                    },
                    afterlayout: function () {
                        setTimeout(function () {
                            $('#locationFilter').html(oMailList.locationFilterOptions);
                            $('#selectableUsers').html(oMailList.selectableUserOptions);
                            $('#selectedUsers').html(oMailList.selectedUserOptions);

                            oMailList.sortOptions('selectableUsers');
                            oMailList.sortOptions('selectedUsers');

                            $('#locationFilterLabel').html(output['t_location_filter'] + ":");
                            $('#nameFilterLabel').html(output['t_name_filter'] + ":");
                            oMailList.dlgMask.hide();

                            $('#nameFilter').focus();
                        }, 200);
                    }
                }
            }).show();
        },
        /**
         *
         * @param {type} Message
         * @returns nothing
         *
         * shows error-messages and hides them after a while
         *
         */
        displayFunctionResult: function (Message) {
            classicErrrorMessage(Message);
            setTimeout(function () {
                classicErrrorMessage("");
            }, 4000);
        },
        /**
         *
         * @returns nothing
         *
         * reduces the userlist from selected list users
         *
         */
        reduceUserList: function () {
            for (mlElem in oMailList.mailListData.dataList) {
                if (oMailList.mailListData.dataList[mlElem] !== null) {
                    for (usElem in oMailList.userData.dataList) {
                        if (oMailList.userData.dataList[usElem] !== null) {
                            if (oMailList.mailListData.dataList[mlElem].id ===
                                oMailList.userData.dataList[usElem].id) {
                                delete oMailList.userData.dataList[usElem];
                                break;
                            }
                        }
                    }
                }
            }
        },
        /**
         *
         * @param {type} cartID
         * @param {type} partnerID
         * @param {type} successFunction
         * @returns nothing
         *
         * loads neccessary data for the selection-
         * dialog in cascading manner
         *
         */
        loadData: function (cartID, partnerID, successFunction) {
            oMailList.cartId = cartID;
            oMailList.partnerId = partnerID;

            if ((oMailList.userData.dataList === undefined || oMailList.locationData.dataList === undefined) ||
                (oMailList.userData.dataList.length === 0 || oMailList.locationData.dataList.length === 0)) {
                oMailList.loadMailListData(
                    cartID,
                    function () {
                        if ((oMailList.userData.dataList === undefined || oMailList.userData.dataList.length === 0)) {
                            oMailList.loadUserData(
                                partnerID,
                                function () {
                                    oMailList.loadLocationData(
                                        partnerID,
                                        function () {
                                            oMailList.reduceUserList();

                                            if (typeof (successFunction) === 'function') {
                                                successFunction();
                                            }
                                        });
                                });
                        } else {
                            oMailList.loadLocationData(
                                partnerID,
                                function () {
                                    oMailList.reduceUserList();

                                    if (typeof (successFunction) === 'function') {
                                        successFunction();
                                    }
                                });
                        }
                    });
            } else {
                if (typeof (successFunction) === 'function') {
                    oMailList.createWindow();
                }
            }
        },
        /**
         *
         * @param {type} partnerID
         * @param {type} successFunction
         * @returns nothing
         *
         * loads the location-data of the given partner
         *
         */
        loadLocationData: function (partnerID, successFunction) {
            oMailList.locationData.dataStatus = 'NODATA';

            var params = {};
            params.partner_id = partnerID;

            AjaxHandlerByClass(
                'ajax/OrderInfo/RequestHandler/LoadLocationData',
                params,
                function (response_data) {
                    oMailList.locationData = JSON.parse(response_data.substring(1, response_data.length - 1));

                    switch ($.trim(oMailList.locationData.result)) {
                        case 'DONE':
                            oMailList.locationData.dataStatus = 'SUCCESS';
                            break;
                        case 'NODATA':
                            oMailList.locationData.dataStatus = 'NODATA';
                            break;
                        default:
                            oMailList.locationData.dataStatus = 'ERROR';
                            break;
                    }

                    if (typeof (successFunction) === 'function') {
                        successFunction();
                    }
                },
                function (xhr, ajaxOptions, thrownError) {
                    oMailList.locationData.dataStatus = 'ERROR';
                }
            );
        },
        /**
         *
         * @param {type} rawUserData
         * @returns nothing
         *
         * sets the Userdata when site is loading
         *
         */
        setUserData: function (rawUserData) {
            if ($.trim(rawUserData) === '') {
                return;
            }

            oMailList.userData = JSON.parse(rawUserData.substring(1, rawUserData.length - 1));

            switch ($.trim(oMailList.userData.result)) {
                case 'DONE':
                    oMailList.userData.dataStatus = 'SUCCESS';
                    break;
                case 'NODATA':
                    oMailList.userData.dataStatus = 'NODATA';
                    break;
                default:
                    oMailList.userData.dataStatus = 'ERROR';
                    break;
            }
        },
        /**
         *
         * @param {type} partnerID
         * @param {type} successFunction
         * @returns nothing
         *
         * loads the user-data of the given partner
         *
         */
        loadUserData: function (partnerID, successFunction) {
            oMailList.userData.dataStatus = 'NODATA';

            var params = {};
            params.partner_id = partnerID;

            AjaxHandlerByClass(
                'ajax/OrderInfo/RequestHandler/LoadUserData',
                params,
                function (response_data) {
                    oMailList.setUserData(response_data);

                    if (typeof (successFunction) === 'function') {
                        successFunction();
                    }
                },
                function (xhr, ajaxOptions, thrownError) {
                    oMailList.userData.dataStatus = 'ERROR';
                }
            );
        },
        /**
         *
         * @param {type} cartID
         * @param {type} successFunction
         * @returns nothing
         *
         * loads the stored user-list of the given cart
         *
         */
        loadMailListData: function (cartID, successFunction) {
            oMailList.mailListData.dataStatus = 'NODATA';

            var params = {};
            params.cart_id = cartID;

            AjaxHandlerByClass(
                'ajax/OrderInfo/RequestHandler/LoadMailList',
                params,
                function (response_data) {
                    oMailList.mailListData = JSON.parse(response_data.substring(1, response_data.length - 1));

                    switch ($.trim(oMailList.mailListData.result)) {
                        case 'DONE':
                            oMailList.mailListData.savedStatus = 'SUCCESS';
                            oMailList.mailListData.dataStatus = 'SUCCESS';
                            break;
                        case 'NODATA':
                            oMailList.mailListData.savedStatus = 'SUCCESS';
                            // thats not an error !! :-)
                            break;
                        default:
                            oMailList.mailListData.savedStatus = 'SUCCESS';
                            oMailList.mailListData.dataStatus = 'ERROR';
                            break;
                    }

                    if (typeof (successFunction) === 'function') {
                        successFunction();
                    }
                },
                function (xhr, ajaxOptions, thrownError) {
                    oMailList.mailListData.savedStatus = 'SUCCESS';
                    oMailList.mailListData.dataStatus = 'ERROR';
                }
            );
        },
        /**
         *
         * @param {type} cartID
         * @param {type} mailList
         * @param {type} successFunction
         * @returns nothing
         *
         * saves the selected user-list of the given cart
         *
         */
        storeMailListData: function (cartID, mailList, successFunction) {
            var params = {};
            params.cart_id = cartID;
            params.mail_list = mailList;

            AjaxHandlerByClass(
                'ajax/OrderInfo/RequestHandler/StoreMailList',
                params,
                function (response_data) {
                    var storeListResponse = JSON.parse(response_data.substring(1, response_data.length - 1));

                    switch ($.trim(storeListResponse.result)) {
                        case 'DONE':
                            oMailList.displayFunctionResult(output['m_mail_list_saved']);
                            oMailList.mailListData.savedStatus = 'SUCCESS';
                            break;
                        default:
                            oMailList.displayFunctionResult(output['m_error_save']);
                            oMailList.mailListData.savedStatus = 'ERROR';
                            break;
                    }

                    if (typeof (successFunction) === 'function') {
                        successFunction();
                    }
                },
                function (xhr, ajaxOptions, thrownError) {
                    oMailList.displayFunctionResult(output['m_error_save']);
                    oMailList.mailListData.savedStatus = 'ERROR';
                }
            );
        }
    };